<!-- 特惠活动 -->
<template>
  <div class="">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="1"></HeaderNav>
    <div class="img_box">
      <div class="pc_img">
        <img alt="" :src="pcImg" style="width: 100%; " />
      </div>
      <div class="wap_img">
        <img alt="" :src="wapImg" style="width: 100%;" />
      </div>
      <vueMiniPlayer ref="vueMiniPlayer" :video="video" :mutex="true" @fullscreen="handleFullscreen" />
    </div>
    <hr class="hr_1 mt0 mb30">
    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import RightNav from '../../components/RightNav.vue'
import { apiGetAdvert, apiGetList, } from '../../api/activity.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    RightNav: RightNav,
  },
  data() {
    return {
      pcImg:'',
      wapImg:'',
      video: {
        url: 'https://api.dogecloud.com/player/get.mp4?vcode=5ac682e6f8231991&userId=17&ext=.mp4',
        cover: 'https://i.loli.net/2019/06/06/5cf8c5d9c57b510947.png',
        muted: false,
        loop: false,
        preload: 'auto',
        poster: '',
        volume: 1,
        autoplay: false
      }
    };
  },
  // computed(){
  //     $video(){
  //       return this.$refs.vueMiniPlayer.$video;
  //     }
  // },
  created() {
    if(this.$route.query.id==1){
      this.pcImg = 'static/picture/1-210R4151U5415.jpg'
      this.wapImg= 'static/picture/1-210q9152551342.jpg'
      this.video.url = ''
      this.video.cover = ''
    }
    if(this.$route.query.id==2){
      this.pcImg = 'static/picture/1-210QF91933933.jpg'
      this.wapImg= 'static/picture/1-210QF91952949.jpg'
      this.video.url = ''
      this.video.cover = ''
    }
    if(this.$route.query.id==3){
      this.pcImg = 'static/picture/1-210G2152G22I.jpg'
      this.wapImg= 'static/picture/1-210G2152646111.jpg'
      this.video.url = 'http://www.ttrans.cn/templets/default/images/abc.mp4'
      this.video.cover = ''
    }
    if(this.$route.query.id==4){
      this.pcImg = 'static/picture/1-21031914263H26.jpg'
      this.wapImg= 'static/picture/1-210319142619640.jpg'
      this.video.url = 'http://www.ttrans.cn/templets/default/images/ms.mp4'
      this.video.cover = ''
    }
    if(this.$route.query.id==5){
      this.pcImg = 'static/picture/1-210319142320M1.jpg'
      this.wapImg= 'static/picture/1-2103191423011E.jpg'
      this.video.url = 'http://www.ttrans.cn/templets/default/images/ly.mp4'
      this.video.cover = ''
    }
    if(this.$route.query.id==6){
      this.pcImg = 'static/picture/1-21031914240c02.jpg'
      this.wapImg= 'static/picture/1-2103191423501I.jpg'
      this.video.url = 'http://www.ttrans.cn/templets/default/images/ys.mp4'
      this.video.cover = ''
    }
    if(this.$route.query.id==7){
      this.pcImg = 'static/picture/1-21012Q12259427.jpg'
      this.wapImg= 'static/picture/1-21012Q50000a9.jpg'
      this.video.url = 'http://www.ttrans.cn/templets/default/images/qjz.mp4'
      this.video.cover = ''
    }
    if(this.$route.query.id==8){
      this.pcImg = 'static/picture/1-21012Q11516352.jpg'
      this.wapImg= 'static/picture/1-21012Q50031496.jpg'
      this.video.url = 'http://www.ttrans.cn/templets/default/images/tmmm.mp4'
      this.video.cover = ''
    }
    if(this.$route.query.id==9){
      this.pcImg = 'static/picture/1-210114093Q0T2.jpg'
      this.wapImg= 'static/picture/1-210114102323T3.jpg'
      this.video.url = 'http://www.ttrans.cn/templets/default/images/jdy.mp4'
      this.video.cover = ''
    }
    if(this.$route.query.id==10){
      this.pcImg = 'static/picture/1-21011409325U46.jpg'
      this.wapImg= 'static/picture/1-200Q31Q918.jpg'
      this.wapImg1= 'static/picture/1-200Q31Q919.jpg'
      this.wapImg2= 'static/picture/1-200Q31Q919-50.jpg'
      this.video.url = 'http://www.ttrans.cn/templets/default/images/zbs.mp4'
      this.video.cover = ''
    }
    if(this.$route.query.id==11){
      this.pcImg = 'static/picture/1-210114093425250.jpg'
      this.wapImg= 'static/picture/1-210114102044106.jpg'
      this.video.url = 'http://www.ttrans.cn/templets/default/images/phs.mp4'
      this.video.cover = ''
    }
    if(this.$route.query.id==12){
      this.pcImg = 'static/picture/1-210114093425250.jpg'
      this.wapImg= 'static/picture/1-210114102044106.jpg'
      this.video.url = 'http://www.ttrans.cn/templets/default/images/phs.mp4'
      this.video.cover = ''
    }
    if(this.$route.query.id==13){
      this.pcImg = 'static/picture/1-210114093501T1.jpg'
      this.wapImg= 'static/picture/1-210114102150K0.jpg'
      this.video.url = 'http://www.ttrans.cn/templets/default/images/qjmm.mp4'
      this.video.cover = ''
    }
    if(this.$route.query.id==14){
      this.pcImg = 'static/picture/1-21011409353G11.jpg'
      this.wapImg= 'static/picture/1-21011410223aT.jpg'
      this.video.url = 'http://www.ttrans.cn/templets/default/images/xmn.mp4'
      this.video.cover = ''
    }
    if(this.$route.query.id==15){
      this.pcImg = 'static/picture/1-210114093615E6.jpg'
      this.wapImg= 'static/picture/1-200G4154Q5123.jpg'
      this.wapImg1= 'static/picture/1-200G4154R1154.jpg'
      this.wapImg2= 'static/picture/1-200G4154RY05.jpg'
      this.video.url = 'http://www.ttrans.cn/templets/default/images/phms.mp4'
      this.video.cover = ''
    }
    if(this.$route.query.id==16){
      this.pcImg = 'static/picture/1-210114093G2422.jpg'
      this.wapImg= 'static/picture/1-200G4151515135.jpg'
      this.wapImg1= 'static/picture/1-200G41515223T.jpg'
      this.wapImg2= 'static/picture/1-200G4151529493.jpg'
      this.video.url = 'http://www.ttrans.cn/templets/default/images/mm.mp4'
      this.video.cover = ''
    }
  },
  methods: {
    handleFullscreen(){

    },
    //立即报名
    submit(n){
      if(this.login == true || this.login  == 'true' ){
        this.houseName = n
        this.maskShow = true
      }else{
        this.$message({ message: '请先登录', type: 'error' });
      }
    },

    //关闭通知弹窗
    closeSanTable(){
      this.maskShow = false
    },

    //翻页
    handleCurrentChange(page) {
      console.log(page);
      this.page = page;
      this.getList();
    },

    //获取列表
    getList() {
      // this.$loading();
      const _this = this;
      var limit = this.pagesize;
      var page = this.page;
      apiGetList({
        limit: limit,
        page: page,
        nameAddress: ''
      })
        .then(res => {
          if (res.success) {
            this.list = res.data.list;
            this.total = Number(res.data.count);
          } else {
            this.$message({ message: res.msg, type: 'error' });
          }
          this.$loading().close();
        })
        .catch(err => {
          this.$message({ message: res.msg, type: 'error' });
          this.$loading().close();
        });
    },

    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
        }
      }
    },

    //获取广告内容
    getAdvert() {
      const _this = this;
      var limit = this.pagesize;
      var page = this.page;
      apiGetAdvert({})
        .then(res => {
          if (res.success) {
            this.advertInfo = res.data.advertInfo;
          } else {
            this.$message({ message: res.msg, type: 'error' });
          }
          this.$loading().close();
        })
        .catch(err => {
          this.$message({ message: res.msg, type: 'error' });
          this.$loading().close();
        });
    },

    //跳转页面    url:  页面地址  parame:  参数 key：参数值
    linkPage: function(url, id, key) {
      if (id == '') {
        this.$router.push({ path: url });
      } else {
        this.$router.push({ path: url, query: { id: key } });
      }
    },

    //跳转到详情页
    linkDetail(id) {
      this.$router.push({ path: '/messageDetail', query: { id: id } });
    },
    
    //跳转到外部链接
    linkOut(url){
      if(url.includes('https://') || url.includes('http://') ){
      	window.location.href = url
      }else{
      	window.location.href = `https://${url}`
      }
    },
    
  }
};
</script>
<style scoped>
@media (min-width: 768px){
	.nav li {
		padding: 0 15px;
	}
	.pc_img{
		display: none;
	}
	.wap_img{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: block;
	}
}


@media (min-width: 1110px) {
	.pc_img{
		display: block;
	}
	.wap_img{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: none;
	}
}
/*------------brand.html  start----------------*/
.img_box{
	width: 100%;
	overflow: hidden;
	margin: 0 auto;
}
.img_box img{
	max-width: 100%;
	margin: 0 auto;
	display: block;
}
.img_box .video_box{
	width: 100%;
	margin: 0 auto;
	position: relative;
}
.img_box .video_box .zhezhao{
	position: absolute;
	height: 100%;
	width: 100%;
	left: 0px;
	top: 0px;
	z-index: 555;
	overflow: hidden;
	cursor: pointer;
}
.img_box .video_box .zhezhao img{
	width: 100%;
	height: 100%;
	transition:all 1s ease-in-out;
}
.img_box .video_box .zhezhao img.img_pc{
	display: block;
}
.img_box .video_box .zhezhao img.img_wap{
	display: none;
}
.img_box .video_box video{
	width: 100%;
}
/*------------brand.html  end----------------*/
</style>



// WEBPACK FOOTER //
// src/view/Activity/index.vue